import {useEffect} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {authorizeGoogle, authorizeMicrosoft, showErrorToast} from '../../helpers';
import { Spinner } from 'stm-frontend-library';
import { useAuth } from '../../components/Auth';

export function SsoAuth() {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const handleAuth = async () => {
            if (searchParams.has('google_oauth_tokens_response')) {
                const oauthTokensResponseEncoded = searchParams.get('google_oauth_tokens_response')
                const oauthTokensResponse = JSON.parse(atob(oauthTokensResponseEncoded));
                const { access_token, id_token } = oauthTokensResponse;

                try {
                    const response = await authorizeGoogle({access_token, id_token});
                    if (response.status === 200 && response.data?.token) {
                        await login(response);
                        navigate('/screened-manuscripts');
                    }
                } catch (error) {
                    navigate('/login');
                    showErrorToast();
                }
            } else if (searchParams.has('microsoft_oauth_tokens_response')) {
                const oauthTokensResponseEncoded = searchParams.get('microsoft_oauth_tokens_response')
                const oauthTokensResponse = JSON.parse(atob(oauthTokensResponseEncoded));

                const { access_token, id_token } = oauthTokensResponse;

                try {
                    const response = await authorizeMicrosoft({access_token, id_token});
                    if (response.status === 200 && response.data?.token) {
                        await login(response);
                        navigate('/screened-manuscripts');
                    }
                } catch (error) {
                    navigate('/login');
                    showErrorToast();
                }
            } else {
                showErrorToast();
            }
        }

        handleAuth();
    }, [navigate, login])

    return <Spinner />;
}
